






import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryFinanceDistributionDailyStatList, ExportFinanceDistributionDailyStat } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({ components: { VQuery, VTable } })
export default class FinanceDistributionDailyStatList extends Vue {
  private queryParam = { startRow: 1, limit: 10, statDateDaterange: [], orderBy: 'stat_date desc', statDateTimeScope: '' }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private tableSelectData: any[] = []
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '统计日期', param: 'statDate', width: 120 },
    { title: '分销首购单数', param: 'distOrderCount' },
    { title: '分销首购PV', param: 'distOrderPvTotal' },
    { title: '分销首购实付', param: 'distPayAmountTotal' },
    { title: '复购单数', param: 'repurchaseOrderCount' },
    { title: '复购PV', param: 'repurchaseOrderPvTotal' },
    { title: '复购实付', param: 'repurchasePayAmountTotal' },
    { title: '复购补贴绿豆', param: 'mungBeanSubsidyTotal' },
    { title: '更新时间', param: 'updateTime', formatter: DateFormat, width: 160 },
  ]

  public created() { this.loadData() }
  private tableSelectChange(e: any[]) { this.tableSelectData = e }
  private exportHandle() {
    const loading = this.$loading({ lock: true, text: '正在导出', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    const param: any = this.getRequestParam()
    param.limit = ''
    param.startRow = ''
    if (this.tableSelectData.length > 0) param.ids = this.tableSelectData.map(e => e.id)
    ExportFinanceDistributionDailyStat(param, '分销复购日汇总.xlsx').finally(() => loading.close())
  }
  public async loadData() {
    const result = await QueryFinanceDistributionDailyStatList(this.getRequestParam())
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam() {
    const param = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length > 0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }
  public search() { this.tableCurrntPage = 1; this.loadData() }
  public pageChange(index: number) { this.tableCurrntPage = index; this.loadData() }
  public sizeChange(index: number) { this.tableCurrntPage = 1; this.queryParam.limit = index; this.loadData() }
}
